import React, { useState } from "react";
import NotesChild from "./NotesChild";
import { formatDate, formatTime } from "../../../common/utils";
import { saveNote } from "../../../features/notes/notesSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

function NotesParent({
  notes,
  ID,
  name,
  time,
  section,
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut ad minim veniam.",
  childNotes,
  key,
  userLogin,
  t,
  id,
  userId,
  lang,
  standardNoteID,
  important,
  threadID,
  submittedPlatform,
  isAddedByInternalUser
}) {
  const [displayChild, setDisplayChild] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [reply, setReply] = useState(false);
  const [replyText, setReplyText] = useState("");
  const dispatch = useDispatch();

  return (
    <div
      key={key}
      className={`${important && "text-red-500"} ${!isAddedByInternalUser && "bg-gray-100"
        } `}
    >
      <div className="pl-[40px] pr-[24px]">
        <div className="border-[#D9D9D9] border-b flex flex-row pb-[16px] pt-[24px]">
          <div style={{ width: 38 }} className="flex flex-col items-start">
            <p style={{ fontSize: 20, color: "red" }}>{important && "!"}</p>{" "}
          </div>
          <div className="flex flex-col items-start w-[145px]">
            <p className="font-[600]">
              {(time && moment(time).format("ll")) || "12/27/2022"}
            </p>
            <p>{(time && moment(time).format("hh:mm A")) || "11:30:47 AM"}</p>
          </div>
          <div className="flex w-[250px]">{name || "tkomasegfha"}</div>
          <div className="flex flex-col items-start w-auto">
            <p
              className="notes__text overflow-hidden w-auto"
              style={{
                WebkitLineClamp: 50,
                WebkitBoxOrient: "vertical",
                display: "-webkit-box",
              }}
            >
              {showAll ? (
                <span dangerouslySetInnerHTML={{ __html: description }}></span>
              ) : (
                <span
                  dangerouslySetInnerHTML={{
                    __html: description.substr(0, 50) + "...",
                  }}
                ></span>
              )}
            </p>
            <div className="flex flex-flow gap-6 mt-2 pr-[120px] self-end">
              {childNotes && childNotes.length > 0 && (
                <div className="flex flex-flow">
                  <button
                    onClick={() => setDisplayChild((prev) => !prev)}
                    type="button"
                    className="flex link hide__reply self-center"
                  >
                    <>{displayChild ? t("hideReplies") : t("showReplies")}</>
                  </button>
                  {displayChild ? (
                    <svg
                      className="ml-3 self-center hide-arrow"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="M4.076 6.309 10 11.693l5.923-5.384"
                        stroke="#526D7D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="hide-arrow ml-3 self-center"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="M4.076 11.691 10 6.307l5.923 5.384"
                        stroke="#526D7D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              )}
              {description && description.length > 47 && (
                <div className="flex flex-row">
                  <button
                    onClick={() => setShowAll((prev) => !prev)}
                    id="show-more"
                    type="button"
                    className="flex link self-center"
                  >
                    {showAll ? t("showLess") : t("showMore")}
                  </button>
                  {showAll ? (
                    <svg
                      className="ml-3 self-center hide-arrow"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="M4.076 6.309 10 11.693l5.923-5.384"
                        stroke="#526D7D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="ml-3 self-center show-arrow"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="M4.076 11.691 10 6.307l5.923 5.384"
                        stroke="#526D7D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              )}
            </div>
            {reply && (
              <textarea
                type="text"
                id="reply-area"
                placeholder={t("NotesPlaceholder")}
                aria-label="What is the relationship between the donor and the attorney."
                className="h-[120px] mt-6 placeholder:text-placeholder w-[482px]"
                spellCheck="false"
                value={replyText}
                onChange={(e) => {
                  setReplyText(e.target.value);
                }}
              />
            )}
          </div>
          <div className="flex items-center justify-end w-[113px] ml-35px">
            {!reply ? (
              <button
                onClick={() => setReply((prev) => !prev)}
                className="break-keep btn__secondary font-[600] h-[40px] leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-[120px]"
              >
                {t("reply")}
              </button>
            ) : (
              <div className="w-full">
              <div className="flex gap-[32px] justify-end w-max">
                <button
                  onClick={() => {
                    setReply((prev) => !prev);
                    setReplyText("");
                  }}
                  type="reset"
                  className="focus-visible:bg-[#ECECEC] font-[600] h-[40px] hover:bg-[#ECECEC]  rounded-sm text-[#E2211C] text-[16px] text-center w-[120px] ml-10"
                >
                  {t("cancel")}
                </button>
                <button
                  id="save-reply"
                  disabled={!replyText}
                  onClick={() => {
                    dispatch(
                      saveNote(
                        parseInt(id) - 100000,
                        replyText,
                        userId,
                        ID,
                        threadID,
                        "CTIC",
                        true,
                        true
                      )
                    );
                    setReplyText("");
                    setReply((prev) => !prev);
                  }}
                  className="!bg-primary-yellow !border-0 break-keep btn__secondary font-[600] h-[40px] items-end leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-[120px]"
                >
                  {t("save")}
                </button>
              </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {displayChild &&
        childNotes &&
        childNotes
          // .sort((a, b) => {
          //   const dateA = new Date(a["createDate"]);
          //   const dateB = new Date(b["createDate"]);
          //   return dateB - dateA;
          // })
          .map((item, index) => (
            <NotesChild
              section={
                lang === "fr" ? item.standardNoteTextFr : item.standardNoteText
              }
              description={item.note}
              key={index}
              childNotes={[...childNotes, ...item.childNotes]}
              time={item.createDate}
              name={item.userName}
              ID={item.noteID}
              notes={notes}
              childID={item.id}
              userLogin={userLogin}
              t={t}
              id={id}
              userId={userId}
              dispatch={dispatch}
              standardNoteID={item?.standardNoteID}
              lang={lang}
              threadID={threadID}
              submittedPlatform={submittedPlatform}
              isAddedByInternalUser={isAddedByInternalUser}
            />
          ))}
    </div>
  );
}

export default React.memo(NotesParent);
